import React from 'react';
import ConnectIcon from '@material-ui/icons/Loop';
import './Loading.scss';

export default function Button() {
    return (
        <ConnectIcon className="loading-icon" />
    );
}
